import { Image } from '@react-pdf/renderer';

import { MarketTrendsChart } from './MarketTrendsChart.js';
import { MarketTrendsExportDeps, MarketTrendsHelpers } from './types.js';

type Props = {
  width?: number;
  height?: number;
  exportDeps?: MarketTrendsExportDeps;
  marketTrendsHelpers: MarketTrendsHelpers;
};

export function MarketTrendsSummaryChart(props: Props) {
  const { width, height, exportDeps, marketTrendsHelpers } = props;

  if (exportDeps !== undefined) {
    if (exportDeps.chartURL === undefined) {
      return <></>;
    }
    return <Image src={exportDeps.chartURL} style={{ width, height }} />;
  }

  return (
    <MarketTrendsChart
      width={width}
      height={height}
      interactive={false}
      marketTrendsHelpers={marketTrendsHelpers}
    />
  );
}
